import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserService} from '../../services/user.service';
import {MsalService} from '@azure/msal-angular';

@Component({
  selector: 'app-sidemenu',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.css'
})
export class SidemenuComponent {
  @Input() menuOpen: boolean = false;
  @Output() navigate = new EventEmitter<string>();

  constructor(
    public msalService: MsalService,
    public userService: UserService
  ) {
  }

  onNavigate(page: string) {
    this.navigate.emit(page);
  }

  logoutRedirect(): void {
    this.msalService.logoutRedirect();
  }

}
